/**
 * Cart Update Bridge
 *
 * Intercepts all fetch calls to Shopify cart mutation endpoints and publishes
 * FoxTheme.pubsub.cartUpdate so that <cart-count> and other subscribers
 * stay in sync — even when third-party scripts (Searchtap, sr-checkout, etc.)
 * modify the cart outside of ProductForm.
 */
(function () {
  if (window.__zopCartBridgeInit) return;
  window.__zopCartBridgeInit = true;

  const CART_ENDPOINTS = [
    '/cart/add.js',
    '/cart/change.js',
    '/cart/update.js',
    '/cart/clear.js',
  ];

  const _fetch = window.fetch;

  function isCartMutation(input) {
    const url = typeof input === 'string'
      ? input
      : (input instanceof Request ? input.url : String(input));
    return CART_ENDPOINTS.some(function (ep) {
      const idx = url.indexOf(ep);
      return idx !== -1 && (idx === 0 || url.charAt(idx - 1) === '/');
    });
  }

  function publishCartUpdate() {
    _fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          window.FoxTheme.pubsub.publish(
            window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            { cart: cart }
          );
        }
      })
      .catch(function () {});
  }

  window.fetch = function (input, init) {
    const promise = _fetch.apply(this, arguments);

    if (isCartMutation(input)) {
      promise.then(function (response) {
        if (response.ok) publishCartUpdate();
      }).catch(function () {});
    }

    return promise;
  };
})();
